import React, { useRef, useState } from 'react'
import publisherlogo from "../assets/publisher-logo.png";
import gamelogo from "../assets/game-logo.png";
import { useLanguage } from '../contexts/LanguageContext';

export default function Start({ setUserName, userName, setQuestionSet }) {
    const { language } = useLanguage();
    //error msg
    const [error, setError] = useState(false);
    //inputRef
    const inputRef = useRef()

    const handleClick = () => {
        //if the input is empty set error to true else, set the value to the username
        if (inputRef.current.value === "") {
            setError(true);
        } else {
            setUserName(inputRef.current.value);
            if (setQuestionSet) setQuestionSet(null); // clear previous selection
        }
    }
    return (
        <div className='start' >
            <div className="logo-bar">
                <img src={publisherlogo} alt={language.altText.publisherLogo} className="logo-left" />
                <img src={gamelogo} alt={language.altText.gameLogo} className="logo-right" />
            </div>
            <div className="content" >                
                <div className="dialog">
                    <h2>{language.start.greeting}</h2>
                    <input type="text" placeholder={language.start.placeholder} className='startInput' ref={inputRef} 
                        onKeyDown={e => { if (e.key === 'Enter') handleClick(); }}
                    />
                    {
                        error && <code>{language.start.errorMessage}</code>
                    }
                    <div className="btn">
                        <button className='main-btn' onClick={handleClick}>{language.start.continueButton}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
